import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }

  connect() {
    this.showHandler = () => this.show()
    this.hideHandler = () => this.hide()
    this.repositionHandler = () => this.position()

    this.element.addEventListener("mouseenter", this.showHandler)
    this.element.addEventListener("focusin", this.showHandler)
    this.element.addEventListener("mouseleave", this.hideHandler)
    this.element.addEventListener("focusout", this.hideHandler)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.showHandler)
    this.element.removeEventListener("focusin", this.showHandler)
    this.element.removeEventListener("mouseleave", this.hideHandler)
    this.element.removeEventListener("focusout", this.hideHandler)
    this.hide()
  }

  show() {
    const content = this.contentValue?.trim()
    if (!content || this.tooltipElement) return

    const node = document.createElement("div")
    node.className = "ui-tooltip-content"
    node.setAttribute("role", "tooltip")
    node.textContent = content
    document.body.appendChild(node)
    this.tooltipElement = node

    this.position()
    window.addEventListener("scroll", this.repositionHandler, true)
    window.addEventListener("resize", this.repositionHandler)
  }

  hide() {
    window.removeEventListener("scroll", this.repositionHandler, true)
    window.removeEventListener("resize", this.repositionHandler)

    if (this.tooltipElement) {
      this.tooltipElement.remove()
      this.tooltipElement = null
    }
  }

  position() {
    if (!this.tooltipElement) return

    const targetRect = this.element.getBoundingClientRect()
    const tooltipRect = this.tooltipElement.getBoundingClientRect()
    const margin = 8
    const gap = 6
    const belowTop = targetRect.bottom + gap
    const aboveTop = targetRect.top - tooltipRect.height - gap

    let top = aboveTop
    let origin = "bottom center"
    if (aboveTop < margin) {
      top = belowTop
      origin = "top center"
    }

    let left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2)
    left = Math.max(margin, Math.min(left, window.innerWidth - tooltipRect.width - margin))

    this.tooltipElement.style.left = `${left}px`
    this.tooltipElement.style.top = `${top}px`
    this.tooltipElement.style.transformOrigin = origin
  }
}
